import React, { useCallback, useMemo, useState } from 'react';
import { useMedia } from 'react-use';
import { MobileCheckContext } from "../../context/MobileCheckContext.js";
import styles from "./MobileCheckProvider.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CSS_VARIABLE_NAME = '--mobile-breakpoint';

/**
 * This provider detects the mobile styling by reading the css breakpoint variable
 * @param children
 * @constructor
 */
export function MobileCheckProvider({
  children
}) {
  const [cssValue, setCssValue] = useState();
  const detectCssValue = useCallback(node => {
    if (node) {
      setCssValue(getComputedStyle(node).getPropertyValue(CSS_VARIABLE_NAME));
    }
  }, []);
  const isMobile = useMedia(`(max-width: ${cssValue})`);
  const value = useMemo(() => ({
    isMobile
  }), [isMobile]);
  return /*#__PURE__*/_jsxs(MobileCheckContext.Provider, {
    value: value,
    children: [/*#__PURE__*/_jsx("div", {
      ref: detectCssValue,
      className: styles.detector
    }), children]
  });
}